import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { provideHooks } from 'redial';
import { connect } from 'react-redux';
import withPageTitle from '../../hoc/withPageTitle';
import normalizeSymbol from '../../service/normalizesymbol';
import { getTickerColumns } from '../../service/tickercolumns';
import { getDeviceBreakpoint } from '../../service/device';
import { requestBrokersData } from '../../actions/brokers';
import { requestDividendsData } from '../../actions/dividends';
import { requestCurrenciesData } from '../../actions/currencies';
import { requestTickerData, fetchCryptocurrency } from '../../actions/ticker';
import { requestNoticesData } from '../../actions/notices';
import { requestOrderData } from '../../actions/orders';
import { requestTradeData } from '../../actions/trades';
import { requestInsidersData } from '../../actions/insiders';

import NotFound from '../../components/NotFound';

import CryptocurrencyInstrument from '../instrument/CryptocurrencyInstrument';

import CurrencyCalculator from '../instrument/CurrencyCalculator';
import Dividends from '../instrument/Dividends';
import Estimates from '../instrument/Estimates';
import Header from '../instrument/Header';
import Insiders from '../instrument/Insiders';
import Notices from '../instrument/Notices';
import Orders from '../instrument/Orders';
import Owners from '../instrument/Owners';
import Summary from '../instrument/Summary';
import Trades from '../instrument/Trades';
import Brokers from '../instrument/Brokers';
import Recommendations from '../instrument/Recommendations';

import css from '../../styles/instrument/instrument';

const hooks = {
    fetch: ({ dispatch, params }) => {
        if (params.symbol.indexOf('.CRYPTO') > -1) {
            return dispatch(fetchCryptocurrency(params.symbol));
        }

        /**
         *  Request basic ticker data, primarily for ticker type,
         *  which informs further columns for a later request
         **/
        return dispatch(requestTickerData(params.symbol, getTickerColumns('COMMON')));
    },
    defer: ({ dispatch, params, getState }) => {
        if (params.symbol.match(/IDCFX$/i) || params.symbol.match(/CRYPTO$/i)) {
            dispatch(requestCurrenciesData());
        }

        /**
         *  Request ticker data based on ticker type
         **/
        const tickerType = getState().tickers[normalizeSymbol(params.symbol)].INSTRUMENT_TYPE;
        if (tickerType === 'CRYPTO') {
            return;
        }
        dispatch(requestTickerData(params.symbol, getTickerColumns(tickerType)));

        dispatch(requestTradeData(params.symbol));
        dispatch(requestOrderData(params.symbol));
        dispatch(requestNoticesData(params.symbol));
        dispatch(requestDividendsData(params.symbol));
        dispatch(requestBrokersData(params.symbol));
        dispatch(requestInsidersData(params.symbol));
    },
};

function mapStateToProps(state, props) {
    const ticker = state.tickers[normalizeSymbol(props.params.symbol)];

    if (!ticker || (ticker && ticker.error)) {
        return {
            notfound: true,
            title: '',
        };
    }

    return {
        title: ticker.LONG_NAME || ticker.SECURITYNAME,
        tickerType: ticker.INSTRUMENT_TYPE,
        breakpoint: getDeviceBreakpoint(state.device.windowWidth),
    };
}

class InstrumentPage extends Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        query: PropTypes.string,
        notfound: PropTypes.bool,
        title: PropTypes.string,
        tickerType: PropTypes.string,
        breakpoint: PropTypes.string,
    };

    render() {
        const { notfound, params: { symbol }, title, tickerType, breakpoint } = this.props;

        if (notfound) {
            return <NotFound />;
        }

        if (tickerType === 'CRYPTO') {
            return (<CryptocurrencyInstrument symbol={symbol} title={title} />);
        }

        return (
            <div className={css.container}>
                <Header symbol={symbol} title={title} breakpoint={breakpoint === 'mobile-small'} />
                <Summary symbol={symbol} />
                <CurrencyCalculator symbol={symbol} instrument />
                <Estimates symbol={symbol} />
                <Recommendations symbol={symbol} />
                <Trades symbol={symbol} title={title} />
                <Orders symbol={symbol} />
                <Notices symbol={symbol} />
                <Dividends symbol={symbol} title={title} />
                <Brokers symbol={symbol} title={title} />
                <Owners symbol={symbol} />
                <Insiders symbol={symbol} title={title} />
                {/* @TODO: Financial component */}
            </div>
        );
    }
}

export default provideHooks(hooks)(
    connect(mapStateToProps)(
        withPageTitle(InstrumentPage)
    )
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/pages/InstrumentPage.js
 **/